import {
  BlackFridayPage,
  getStaticProps,
} from '@public/CmsPage/ShowroomPage/BlackFridayPage'

export { getStaticProps }

export default BlackFridayPage
